import { dataLayerPush } from '@libs/analytics';

export const trackSelectStore = (linkText: string) => {
    dataLayerPush({
        event: 'search_select_store',
        link_text: linkText.toLowerCase(),
    });
};
